module.exports = __webpack_public_path__ + "img/USA.0e7d0731.svg";